import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useTrainingCourse'

import { TrainingCourseModel } from '@models/types'

const generateTabBarItems = (trainingCourse: TrainingCourseModel) => {
  const urls = generateUrls(trainingCourse)
  const { editTrainingCourseUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editTrainingCourseUrl,
      key: 'details',
      title: trainingCourse?.title || 'Training Course Details',
    },
  ]
}

export default generateTabBarItems
